import { DateTime } from 'luxon';

const mesoWestDateFormat = 'yLLddHHmm';

export default class {

  static isoToMesoWest(date, opts) {
    // FROM:  2017-12-21 or 2017-6-6
    // TO:    201306011800

    if (opts.startOf) {
      return DateTime.fromISO(date, 'yyyy-M-d').startOf('day').toFormat(mesoWestDateFormat);
    }

    if (opts.endOf) {
      return DateTime.fromISO(date, 'yyyy-M-d').endOf('day').toFormat(mesoWestDateFormat);
    }

    return DateTime.fromISO(date, 'yyyy-M-d').toFormat(mesoWestDateFormat);
  }

}



// WEBPACK FOOTER //
// ./src/utils/date.js